import { BaseEntity } from "@common/ADAPT.Common.Model/base-entity";
import { BreezeModelBuilder } from "@common/ADAPT.Common.Model/breeze-model-builder";
import { EntityExtensions } from "../entity-extensions.decorator";
import { ProgressCategoryExtensions } from "./progress-category-extensions";
import { ProgressItem } from "./progress-item";
import { ProgressProduct } from "./progress-product";

export class ProgressCategory extends BaseEntity<ProgressCategory> {
    public progressCategoryId!: number;
    public progressProductId!: number;
    public name!: string;
    public ordinal!: number;

    public progressProduct!: ProgressProduct;
    public progressItems!: ProgressItem[];

    @EntityExtensions(ProgressCategoryExtensions)
    public extensions!: ProgressCategoryExtensions;
}

// not accessible directly, we fetch this via nav prop on ProgressProduct
export const ProgressCategoryBreezeModel = new BreezeModelBuilder("ProgressCategory", ProgressCategory)
    .build();
